<div class="bullet-list">
  <div *ngFor="let bullet of bullets; let last = last" class="bullet-item">
    <ion-icon aria-hidden="true" *ngIf="bullet.icon"
      [src]="bullet.icon | srcAssets: 'icons'"
      class="xxl primary-icon">
    </ion-icon>
    <div class="ion-text-left">
      <h4 *ngIf="bullet.title" class="bullet-item-title h4 ion-bold-text">
        {{ bullet.title | translate }}
      </h4>
      <div>
        <p class="bullet-item-message">
          {{ bullet.message | translate }}
        </p>
        <ion-button
          [attr.aria-label]="bullet.message + '_tooltip' | ariaLabel | translate"
          *ngIf="bullet.tooltip"
          color="secondary"
          fill="clear"
          class="button-circle button-small ion-no-margin"
          (click)="openInfoModal(bullet.message)">
          <ion-icon
            slot="icon-only"
            [src]="'information' | srcAssets">
          </ion-icon>
        </ion-button>
      </div>
    </div>
  </div>
</div>
